import type { FC } from 'react';

interface LearningProgressBarProps {
  completed: number;
  total: number;
  size?: 'sm' | 'md';
}

/**
 * Barre de progression reutilisable pour le Learning Hub.
 */
export const LearningProgressBar: FC<LearningProgressBarProps> = ({ completed, total, size = 'md' }) => {
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;
  const height = size === 'sm' ? 'h-1.5' : 'h-2';

  return (
    <div className="flex items-center gap-2">
      <div className={`flex-1 ${height} rounded-full bg-slate-200 dark:bg-slate-600 overflow-hidden`}>
        <div
          className={`${height} rounded-full transition-all duration-500 ${
            pct === 100
              ? 'bg-emerald-500 dark:bg-emerald-400'
              : 'bg-blue-500 dark:bg-blue-400'
          }`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="text-xs text-slate-500 dark:text-slate-400 whitespace-nowrap tabular-nums">
        {completed}/{total}
      </span>
    </div>
  );
};
